export * from './AuthService'
export * from './Consultation'
export * from './CountService'
export * from './PostsService'
export * from './TestsService'
export * from './Doctor'